import { downloadBlob, getBlob, postApi } from "../../common/actions/net";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import { ContentTypes } from "../../common/net/httpClient";
import Logger from "../../common/util/Logger.js";
import { getApi } from "../../common/actions/net.js";

export const SET_HUB_OVERVIEW = "SET_HUB_OVERVIEW";
export const SORT_HUB_PRODUCTS = "SORT_HUB_PRODUCTS";
export const SORT_HUB_CUSTOMERS = "SORT_HUB_CUSTOMERS";
export const SET_SORTING_PRODUCTS = "SET_SORTING_PRODUCTS";
export const SET_SORTING_CUSTOMERS = "SET_SORTING_CUSTOMERS";


/**
 * Gets hub overview
 * @param {number} hubId
 * @returns {func}
 */
export function getHubOverview(hubId) {
    return async dispatch => {
        try {
            // Call webApi to get a list of invoice groups
            const { payload } = await dispatch(
                getApi("FreshFoodHub/GetHubOverViewQuery",
                    {
                        hubId : hubId,
                    }));

            dispatch({
                type: SET_HUB_OVERVIEW,
                payload: payload
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av oversikt mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Creates a pdf with overview of the selected date
 * @param {object} productionDate
 * @returns {func}
 */
export function showOverviewPdf(productionDate){
    return async (dispatch, getState) => {
        try {
            const state = getState();

            const blob = await getBlob("FreshFoodHub/GenerateOverviewPdf", 
                {
                    hubId : state.authentication.hubId,
                    productionDate : productionDate,                   
                }
                ,  state.authentication.token, ContentTypes.JSON, ContentTypes.PDF, false);
            downloadBlob(blob, `${productionDate}.pdf`, ContentTypes.PDF);

        } catch (error) {
            dispatch( pushSystemMessage(error.message || "Fil ikke funnet", messageType.error) );
            Logger.error(error);
        }
    };
}

/**
 * Creates a Excel file with overview of the selected date
 * @param {object} productionDate
 * @returns {func}
 */
export function showOverviewExcel(productionDate){
    return async (dispatch, getState) => {
        try {
            const state = getState();

            const blob = await getBlob("FreshFoodHub/GenerateOverviewExcel", 
                {
                    hubId : state.authentication.hubId,
                    productionDate : productionDate,                   
                }
                ,  state.authentication.token, ContentTypes.JSON, ContentTypes.EXCEL, false);
            downloadBlob(blob, `${productionDate}.xlsx`, ContentTypes.EXCEL);

        } catch (error) {
            dispatch( pushSystemMessage(error.message || "Fil ikke funnet", messageType.error) );
            Logger.error(error);
        }
    };
}

/**
 * Sets the sorting mode
 * @param {boolean} sorting 
 * @returns {func}
 */
export function setProductsSortingMode(sorting){
    return async (dispatch) => {
        try {
            await dispatch({
                type: SET_SORTING_PRODUCTS,
                sorting : sorting,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Sets the sorting mode
 * @param {boolean} sorting 
 * @returns {func}
 */
export function setCustomersSortingMode(sorting){
    return async (dispatch) => {
        try {
            await dispatch({
                type: SET_SORTING_CUSTOMERS,
                sorting : sorting,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}


/**
 * Updates the sort order of the products
 * @param {number} index1 
 * @param {number} index2
 * @param {number} dateIndex
 * @param {boolean} thisWeek
 * @returns {func}
 */
export function updateHubProductSortOrder(index1, index2, dateIndex, thisWeek){
    return async (dispatch, getState) => {
        try {

            // Peform immediate update of state
            dispatch({
                type: SORT_HUB_PRODUCTS,
                index1: index1,
                index2: index2,
                dateIndex: dateIndex,
                thisWeek: thisWeek,
            });

            const state = getState();
            var products = thisWeek ?
                state.freshFoodHub.overview.currentWeekProductionDates[dateIndex].plannedProductsForDate :
                state.freshFoodHub.overview.nextWeekProductionDates[dateIndex].plannedProductsForDate;

            const sortCmd = {
                hubId: state.authentication.hubId,
                sortedProducts: products.map((p, index) => { return {productId: p.productId, newSortOrder: index }; })
            };

            // Call API to set new sort order
            await dispatch(postApi("FreshFoodHub/UpdateHubProductsSortOrder", sortCmd));   

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Sortering av varer for smørehub mislyktes", messageType.error));
            Logger.error(error);
        } 
    };
}

/**
 * Updates the sort order of the customers
 * @param {number} index1 
 * @param {number} index2
 * @param {number} dateIndex
 * @param {boolean} thisWeek
 * @returns {func}
 */
export function updateHubCustomerSortOrder(index1, index2, dateIndex, thisWeek){
    return async (dispatch, getState) => {
        try {

            // Peform immediate update of state
            dispatch({
                type: SORT_HUB_CUSTOMERS,
                index1: index1,
                index2: index2,
                dateIndex: dateIndex,
                thisWeek: thisWeek,
            });

            const state = getState();
            var customers = thisWeek ?
                state.freshFoodHub.overview.currentWeekProductionDates[dateIndex].customers :
                state.freshFoodHub.overview.nextWeekProductionDates[dateIndex].customers;

            const sortCmd = {
                hubId: state.authentication.hubId,
                sortedCustomers: customers.map((c, index) => { return {customerId: c.customerId, newSortOrder: index }; })
            };

            // Call API to set new sort order
            await dispatch(postApi("FreshFoodHub/UpdateHubCustomersSortOrder", sortCmd));   

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Sortering av kunnder for smørehub mislyktes", messageType.error));
            Logger.error(error);
        } 
    };
}

